import * as z from 'zod';

export const realtimeStrategy = z.enum(['small', 'medium']);
export type RealtimeStrategy = z.infer<typeof realtimeStrategy>;

export const mercureSubscription = z.object({
    hubUrl: z.string(),
    topic: z.string(),
    token: z.string().nullable(),
    strategy: realtimeStrategy.nullable(),
});

export type MercureSubscription = z.infer<typeof mercureSubscription>;
